module.exports = {"410802001":"民生街道","410802002":"民主街道","410802003":"新华街道","410802004":"焦西街道","410802005":"焦南街道","410802006":"焦北街道","410802007":"七百间街道","410802008":"上白作街道","410802009":"王褚街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410802.json
// module id = 1719
// module chunks = 0